import {
  getAvatarColorsFromName,
  getInitialsFromName,
} from "./utils/displayNameAvatar";

interface DisplayNameAvatarProps {
  name: string | null | undefined;
  showName?: boolean;
}

export const DisplayNameAvatar = ({
  name,
  showName = false,
}: DisplayNameAvatarProps) => {
  if (!name) return <>-</>;

  const initials = getInitialsFromName(name);
  const { backgroundColor, color } = getAvatarColorsFromName(name);

  return (
    <div className="d-flex align-items-center gap-2">
      <span
        className="c-avatar c-avatar--round c-avatar--sm"
        style={{ backgroundColor, color, zIndex: 6 }}
        aria-label={showName ? undefined : name}
      >
        {initials}
      </span>
      {showName ? <span>{name}</span> : null}
    </div>
  );
};
